import { useContext, useEffect } from 'react'
import { withStyles } from '@material-ui/core/styles'
import styles from '../dashboardStyles'

import { Typography } from '@material-ui/core'

import dayjs from 'dayjs'
import { reducerContext } from '../../../../../contextApi\'s/contextApi\'s'
import taskDetails from '../../../../../helpers/taskDetails'
import { httpRequest } from '../../../../../ui-utils/api'
import { apiUrl } from '../../../../../ui-utils/apiConfig'

const CallHistory = ({ classes }) => {

    const { state, dispatch } = useContext(reducerContext)

    const { callHistory, callHistoryChat, tagPreviousIssue, customerEmail, callAccept, callerInfoModal } = state
    // Dev Srini 25/10/24
    useEffect(()=> {
        if(customerEmail && callAccept){
            ( async () => {
                try {
                    const result = await httpRequest({
                        endPoint: `${apiUrl.customerEmail}/${customerEmail}`,
                        method: "get",
                        instance: "instanceOne",
                    })
    
                    if (result.success) {
                        dispatch({
                            type: 'SET_CALL_HISTORY',
                            payload: result.data.msg
                        })
                    }
                    else{
                        console.log('Error on CustomerEmail/CallHistory API', result)
                    }
                }
                catch (error) {
                    console.log('Error on CustomerEmail/CallHistory API', error)
                }
            })()
        }
        
    }, [customerEmail, callAccept, dispatch])

    useEffect( () => {
        if(callerInfoModal && customerEmail.length > 0){
            taskDetails(customerEmail, dispatch)
        }
    }, [callerInfoModal, customerEmail])

    return (
        <div style={{ flex: '25%' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginLeft: '65px' }}>
                <div className={classes.line} ></div>
                <Typography className={classes.historytext}>Call History</Typography>
                <div style={{ width: '735px', height: '1px', flexShrink: 0, borderRadius: '4px', background: '#000' }}></div>
            </div>

            <div style={{ display: 'flex', height: "100px" }}>
                <div className={classes.callhistory} style={{ flex: 1 }}>
 
                    {callHistory.sort((a, b) => {
                        return new Date(b.task_updated) - new Date(a.task_updated)
                    })
                    .filter(ele => ele.description.toLowerCase().includes(tagPreviousIssue.toLowerCase()))
                    .map(ele => {
                        return (
                            <div 
                            // srini - 14/11/24
                            key={ele.uid}
                            onClick={() => {
                                dispatch({
                                    type: 'SET_CALL_HISTORY_CHAT',
                                    payload: ele.task
                                })
                                
                                dispatch({
                                    type: 'SET_UID',
                                    payload: ele.uid
                                })
                                
                                dispatch({
                                    type: 'SET_TAG_PENDING_ISSUE',
                                    payload: ele.description
                                })
                            }}>
                                <Typography className={classes.callhistorylayout} style={{ display: 'flex', flexDirection: 'column' }}>
                                    <span style={{ alignSelf: "flex-end", marginRight: '5%' }} className={classes.datetext1}>{dayjs(ele.task_updated).format("DD/MM/YY HH : mm a")}</span>

                                    <div style={{ display: 'flex', alignItems: 'center' }}>

                                        <div style={{ width: '2px', height: '20px', flexShrink: 0, borderRadius: '1px', background: ele.status == "Closed" ? '#388415' : "var(--CTA, #F74542)" }}></div>

                                        <span className={classes.callhistoryrecords}>{ele.description}</span>
                                    </div>
                                </Typography>
                            </div>
                        )
                    })}
                </div>

                <div 
                    className={callHistoryChat.length === 1 ? classes.callhistorycard : classes.callhistorycard1}
                >

                    {callHistoryChat.sort((a, b) => {
                        return new Date(b.updatedon) - new Date(a.updatedon)
                    }).map((ele, i) => {
                        return (
                            <div 
                            // srini - 14/11/24
                            key={i}>
                                <Typography className={classes.callhistorylayout1} style={{ display: 'flex', flexDirection: 'column' }}>

                                    <span style={{ alignSelf: "flex-end", marginRight: '5%' }} className={classes.datetext1}>{dayjs(ele.updatedon).format("DD/MM/YY HH : mm a")}</span>

                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <span className={classes.callhistoryrecords}>{ele.call_description}</span>
                                    </div>
                                </Typography>

                                <Typography className={classes.callhistorylayout2} style={{ display: 'flex', flexDirection: 'column' }}>

                                    <span style={{ alignSelf: 'flex-end', marginRight: '2%' }} className={classes.datetext1}>{dayjs(ele.updatedon).format("DD/MM/YY HH : mm a")}</span>

                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <span className={classes.callhistoryrecords}>{ele.comment}</span>
                                    </div>
                                </Typography>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default withStyles(styles)(CallHistory)